import { clsx } from 'clsx';
import type { ReactNode } from 'react';

/* ── Types ────────────────────────────────────────────────────────── */

const SIZE_MAP = {
  narrow: 'max-w-3xl',
  default: 'max-w-4xl',
  wide: 'max-w-7xl',
  full: '',
} as const;

export type PageContainerSize = keyof typeof SIZE_MAP;

export interface PageContainerProps {
  /** @default 'default' */
  size?: PageContainerSize;
  children: ReactNode;
  className?: string;
}

/* ── Component ────────────────────────────────────────────────────── */

/**
 * PageContainer — standardized page layout wrapper.
 *
 * Provides consistent max-width, horizontal padding, vertical spacing,
 * and centering across all pages.
 *
 *   <PageContainer size="wide">
 *     <PageHeader title="Sales Pipeline" />
 *     ...content...
 *   </PageContainer>
 */
export function PageContainer({
  size = 'default',
  children,
  className,
}: PageContainerProps) {
  return (
    <div
      className={clsx(
        'mx-auto px-4 py-6 sm:px-6',
        SIZE_MAP[size],
        className,
      )}
    >
      {children}
    </div>
  );
}
